import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useSeo from "@/hooks/useSeo";
import { faqs, siteMeta } from "@/mocks/comics";

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useSeo({
    title: "常见问题 - 韩漫YY榜 榜单更新与分类筛选帮助",
    description:
      "关于韩漫YY榜人气榜单更新频率、完结漫画分类、新番抢先看、评分机制与选书方法的常见问题解答，帮你更好地使用榜单快速找到想看的韩漫。",
    keywords: "韩漫yy常见问题,韩漫榜单更新,韩漫分类,韩漫完结漫画,韩漫评分",
    path: "/faq",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-16 md:pt-20">
        <section className="mx-auto max-w-[1000px] px-4 md:px-6 py-12 md:py-16">
          <nav aria-label="面包屑" className="text-sm text-foreground-600">
            <ol className="flex flex-wrap items-center gap-2">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li aria-current="page" className="text-foreground-900">常见问题</li>
            </ol>
          </nav>

          <div className="mt-6 text-center">
            <p className="text-sm font-medium text-primary-600">HELP CENTER</p>
            <h1 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
              关于榜单、分类与选书方法的疑问，都能在这里找到答案。如果还有别的问题，欢迎联系我们。
            </p>
          </div>

          <div className="mt-10 divide-y divide-background-200/70 rounded-lg bg-background-100 px-5 md:px-7">
            {faqs.map((f, i) => {
              const isOpen = openIndex === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && <p className="pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 rounded-lg bg-background-100 px-6 py-8 text-center sm:flex-row sm:justify-between sm:text-left">
            <div>
              <h2 className="text-base font-semibold text-foreground-950">还有疑问？</h2>
              <p className="mt-1 text-sm text-foreground-600">发送邮件给我们，我们会尽快回复你的问题。</p>
            </div>
            <a
              href={`mailto:${siteMeta.email}`}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i> 联系我们
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}